<template>
  <div class="card">

    <div class="box-header-wrap">
      <div class="box-header">
        <div class="box-header-inner">
          <p> {{title}}</p>
        </div>
        <!--<span>{{subTitle}}</span>-->
        <span v-if="isIdcDropdown && !isYearDropdown">{{selectedIdc.locationName}} - {{subTitle}}</span>
        <span v-if="!isIdcDropdown && !isYearDropdown">{{subTitle}}</span>
        <span v-if="!isIdcDropdown && isYearDropdown">{{selectedYear.name}}년 01월 01일 ~ {{selectedYear.value == new Date().getFullYear() ?  getDateSimpleStr(new Date(new Date() - (24*60*60*1000))) : selectedYear.name+'년 12월 31일'}}</span>
        <span v-if="isIdcDropdown && isYearDropdown">{{selectedIdc.locationName}} - {{selectedYear.name}}년 01월 01일 ~ {{selectedYear.value == new Date().getFullYear() ?  getDateSimpleStr(new Date(new Date() - (24*60*60*1000))) : selectedYear.name+'년 12월 31일'}}</span>
      </div>
    </div>

    <div class="box-tool">
      <div v-if="isYearDropdown" class="dropdown inline type-fix">
        <button class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{ selectedYear.name }}</button>
        <div class="dropdown-menu dropdown-menu-scale pull-right">
          <ul>
            <li>
              <a class="dropdown-item title" style="padding-right: 23px;">년도</a>
              <ul>
                <li v-for="year in getYearList()" @click="yearClick(year)">
                  <a class="dropdown-item" :class="{'selected' : year.value==selectedYear.value}" style="padding-right: 23px;">{{year.name}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="isIdcDropdown" class="dropdown inline">
        <a data-toggle="dropdown" class="btn btn-m flat" aria-expanded="false"><i class="icon-setting"></i></a>
        <div class="dropdown-menu dropdown-menu-scale pull-right">
          <ul>
            <li v-for="location in idcList" @click="idcClick(location)">
              <a class="dropdown-item" :class="{'selected' : location.locationCode == selectedIdc.locationCode}"> {{ location.locationName}} </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="box-body">
      <div class="row mv-20" style="height:217px;">
        <!--<div class="col-12 text-center">-->
          <slot name="chart" :selectedYear="selectedYear.value" :selectedIdc="selectedIdc"></slot>
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>

  import Dropdown from '@/components/Dropdown.vue';

  export default {
    name: "StatisticsBox",
    components: {
      Dropdown
    },
    props: {
      title: {
        type: String,
        default: function(){
          return 'Title';
        }
      },
      subTitle: {
        type: String,
        default: function() {
          return 'SubTitle';
        }
      },
      isYearDropdown:{
        type: Boolean,
        default: function() {
          return true;
        }
      },
      isIdcDropdown:{
        type: Boolean,
        default: function() {
          return true;
        }
      },
      startYear:{
        type: Number,
        default: function(){
          return 2013;
        }
      },
      isAllYear:{
        type: Boolean,
        default: function(){
          return true;
        }
      }
    },
    computed:{
      nowYear: function(){
        return new Date().getFullYear();
      }

    },
    data() {
      return {
        selectedIdc : null,
        selectedYear : {value : new Date().getFullYear(), name: new Date().getFullYear()},
        idcList: null
      }
    },
    mounted: function(){
      // this.getIdcList();
      this.getUserIdcAuth();
    },
    methods: {
      getYearList : function(){
        let result = [];
        if(this.isAllYear) result.push({name : '전체', value : 'all'});

        for(let i = this.nowYear ; i >=this.startYear; i--){
          result.push({name : i, value: i});
        }
        return result;
      },
      yearClick: function(year){
        this.selectedYear = year;
      },
      getIdcList : async function(){
        this.idcList = await this.$store.getters['location/location'];
      },
      getUserIdcAuth: function(){
        this.getIdcList().then(() => {
          // let filteredList = this.idcList.filter(x => x.locationCode == this.$store.getters['login/getDefaultIdcCode']);
          let filteredList = this.idcList.filter(x => {
            if(this.$store.getters['location/currentIdc']) return x.locationCode == this.$store.getters['location/currentIdc'].locationCode;
            else return x.locationCode == this.$store.getters['login/getDefaultIdcCode'];
          });

          if(filteredList.length > 0)  this.selectedIdc = filteredList[0];
          else this.selectedIdc =  this.idcList[0];
        });
      },
      idcClick: function(idc){
        this.selectedIdc = idc;

        if(!this.isYearDropdown) this.$emit('changeIdc', idc.locationCode);
        else this.$emit('changeIdc', idc.locationCode, this.selectedYear.value);
      },
      yearClick: function(year){
        this.selectedYear = year;
        if(!this.isIdcDropdown) this.$emit('changeYear', year.value);
        else this.$emit('changeYear', this.selectedIdc.locationCode, year.value);
      }
    }
  }
</script>

<style scoped>

</style>
